<template>
  <r-panel :title="title" :button_add="true" @click_add="row_create">

    <v-data-table
        :headers="customHeaders"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer
        dense
        :show-select="bulkMode"
        v-model="selected"
        item-key="_rowKey"
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <div v-if="showBulk && (items.length >= 2)" class="d-flex pl-4 pb-1 align-center">
          <v-checkbox
            v-model="bulkMode"
            hide-details
            :disabled="!items.length"
            class="mt-0 pt-0"
          />

          <v-btn
            x-small
            class="ma-2 white--text"
            color="red"
            :disabled="!bulkMode || !deletableCountLocal"
            @click="bulkRemove"
          >
            Bulk Delete
            <span v-if="deletableCountLocal"> ({{ deletableCountLocal }})</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:item.label="{item}">
        {{ label + " " + getItemIndex(item) }}
      </template>
      <template v-slot:item.day="{item}">
        {{ item.points }}
      </template>
      <template v-slot:item.percent="{item}">
        {{ item.percent + "%" }}
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>

    <r-stash-bonus-bunch-dialog ref="dialog"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {StashBonusBunchGroup} from "@/modules/redactor/models/stash/StashBonusBunchGroup";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RStashBonusBunchDialog from "@/modules/redactor/views/stash/r-stash-bonus-bunch-dialog.vue";

export default {
  name: "r-stash-bonus-bunch-panel",
  components: {RStashBonusBunchDialog, RPanel},
  props: {
    title: VueTypes.string.def("Stash Bonus Bunch"),
    label: VueTypes.string.def("Bunch"),
    model: VueTypes.instanceOf(StashBonusBunchGroup),
    days: VueTypes.bool.def(false),
    points: VueTypes.bool.def(false),
    percent: VueTypes.bool.def(false),
    productGroups: VueTypes.arrayOf(ProductGroupKind).def([]),
    showBulk: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      {text: 'Label', value: 'label', sortable: false},
      {text: 'Key', value: 'key', sortable: false},
      {text: 'Day', value: 'day'},
      {text: 'Points', value: 'points'},
      {text: 'Percent', value: 'percent'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    selected: [],
    bulkMode: false,
  }),
  computed: {
    customHeaders() {
      return this.headers.filter(v => {
        if (v.value === "day") {
          return this.days;
        } else if (v.value === "points") {
          return this.points;
        } else if (v.value === "percent") {
          return this.percent;
        } else {
          return true;
        }
      });
    },
    value() {
      if (this.model) {
        return this.model;
      }
      let value = new StashBonusBunchGroup();
      this.$emit("update:model", value);
      return value;
    },
    items() {
      return this.value.items;
    },
    empty() {
      return this.items.length === 0;
    },
    config() {
      return {
        days: this.days || false,
        points: this.points || false,
        percent: this.percent || false,
        productGroups: this.productGroups || []
      };
    },
    deletableCountLocal() {
      return this.selected.length;
    },
  },
  methods: {
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy(), this.config)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null, this.config)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone(), this.config)
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },

    bulkRemove() {
      if (!this.selected.length) return;

      this.$confirm("Are you sure you want to delete selected items?")
        .then(() => {
          this.selected.forEach(item => {
            const index = this.items.indexOf(item);
            if (index !== -1) {
              this.items.splice(index, 1);
            }
          });
          this.selected = [];
          this.bulkMode = false;
        })
        .catch(() => {});
    },

    getItemIndex(item) {
      return this.items.indexOf(item);
    },
  },

  watch: {
    items: {
      handler(newItems) {
        newItems.forEach((item, index) => {
          item._rowKey = `${this.label} ${index}`;
        });

        this.selected = this.selected.filter(v => newItems.includes(v));
      },
      immediate: true,
    },

    bulkMode(value) {
      if (!value) {
        this.selected = [];
      }
    }
  }
}
</script>
